//http请求配置
import axios from 'axios'
import config from '../lib/base'
import Utils from '../lib/utils'

import {
    Loading
} from 'element-ui';

/**
 *  method: 请求方法。e.g: get/post/delete/put/patch
 *  url: 请求地址
 *  params: 默认为data {}; 当{}对象里包含params时，加入代码中的判断
 *  successCallback: 成功回调函数
 *  errorHandler: 处理错误代码函数
 */
export const request = obj => new Promise((resolve, reject) => {

    const {
        method = 'POST', data
    } = obj;
    let {
        url,
        header = {}
    } = obj;

    if (method.toLowerCase() === 'get') {
        config.serviceConfig.params = data;
    } else {
        config.serviceConfig.data = data;
    }
    config.serviceConfig.method = method;
    config.serviceConfig.url = url;
    config.serviceConfig.header = { ...header
    };

    let loading = Loading.service({
        lock: true,
        text: '拼命加载中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0)',
        customClass: 'loading-box'
    });

    //返回请求数据
    axios(config.serviceConfig)
        .then(function(response) {
            //成功回调
            let data = response.data;
            if (data.code == 0) {
                resolve(data.content);

            } else if (data.code == 5) {
                Utils.delCookie('user');
                Utils.delCookie('permissions');
                window.ROOT_APP.$store.commit("SET_USERINFO", ''); //更新登录状态
                window.ROOT_APP.$router.push({
                    path: '/login'
                });
            } else {
                window.ROOT_APP.$message({
                    type: 'warning',
                    // message: data.msg
                    message: data.content
                });
                reject(data.content)
            }
        })
        .catch(function(error) {
            let msg = '网络翻船中';
            console.log("Error",error);
            if (error.response) {
                // 发送请求后，服务端返回的响应码不是 2xx
            } else if (error.request) {
                //发送请求但是没有响应返回 - 签名失效，重登
                msg = '请重新登录！'
               /* window.ROOT_APP.$router.push({
                    path: '/login'
                }); */
            } else {
                //其他错误
                console.log('Error5', error.message);
            }

            window.ROOT_APP.$message({
                type: 'warning',
                message: msg
            });
            reject();
        })
        .finally(() => {
            loading.close();
        })

})



// WEBPACK FOOTER //
// ./src/lib/http_request.js